
import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    loading: 'Loading...',
  },
  ru: {
    loading: 'Загрузка...',
  },
  uz: {
    loading: 'Yuklanmoqda...',
  },
});
